import {
    IAcaoEtapa,
    IAcaoEtapaResponse,
    IAcoesAcessoUsuario,
    IListarAcoesVinculadasDesvinculadasPorGrupo,
} from "../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export const ListarAcaoEtapaService = (ID_ETAPA: number, idCaso?: number) =>
    Service(
        Axios.get<IAcaoEtapaResponse>(
            `/home/acaoetapacategoriaatendimento/listaracoesporetapacategoriaatendimentotipocaso?ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA}&ID_CASO=${
                idCaso ?? 0
            }`
        )
    );

export const CadastrarAcaoEtapaService = (data: IAcaoEtapa) =>
    Service(
        Axios.post(
            `/home/acaoetapacategoriaatendimento/inseriracaoetapacategoriaatendimentotipocaso`,
            data
        )
    );

export const DeletarAcaoEtapaService = (
    ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) =>
    Service(
        Axios.delete(
            `/home/acaoetapacategoriaatendimento/deletaracaoetapacategoriaatendimentotipocaso?ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}`
        )
    );

export async function AlterarEtapaManualmenteService(
    idCaso: number,
    novaEtapa: number,
    justificativa: string
) {
    return Service(
        Axios.put(
            `/home/atendimentos/alteraretapamanualmente?idCaso=${idCaso}&novaEtapa=${novaEtapa}&justificativa=${justificativa}`
        )
    );
}

export const ListarAcoesVinculadasDesvinculadasPorGrupoService = (
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number,
    ID_GRUPO: number
) =>
    Service(
        Axios.get<IListarAcoesVinculadasDesvinculadasPorGrupo>(
            `home/acaoetapacategoriaatendimento/listaracoesvinculadas?ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}&ID_GRUPO=${ID_GRUPO}`
        )
    );

export const ListAcoesAcessoUsuarioService = (
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) =>
    Service(
        Axios.get<IAcoesAcessoUsuario[]>(
            `home/acaoetapacategoriaatendimento/listacoesacessousuario?ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO=${ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}`
        )
    );
